import "../styles/globals.css";
import { ManagedUIContext } from "@context/context";
import { FirebaseAuthProvider } from "@react-firebase/auth";
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import { config } from "@config/firebase-config";
import NextHead from "next/head";
import { SessionProvider } from "next-auth/react";
import LaunchDarklyProvider from "LaunchDarklyProvider";

const MyApp = ({ Component, pageProps }) => {
  const Layout = Component.Layout || Noop;

  return (
    <SessionProvider session={pageProps.session}>
      <LaunchDarklyProvider> 
        <ManagedUIContext>
          <FirebaseAuthProvider firebase={firebase} {...config}>
            <NextHead>
              <meta
                name="viewport"
                content="width=device-width, initial-scale=1.0, maximum-scale=1.0,user-scalable=0"
              />
            </NextHead>
            <Layout pageProps={pageProps}>
              <Component {...pageProps}></Component>
            </Layout>
          </FirebaseAuthProvider>
        </ManagedUIContext>
      </LaunchDarklyProvider>
    </SessionProvider>
  );
};

export default MyApp;
const Noop = ({ children }) => <>{children}</>;